// import { Component, Prop, Vue } from 'vue-property-decorator';
// import Loader from '@/components/Loader/index.vue';

// import { validationMixin } from 'vuelidate'
// import { required, email } from 'vuelidate/lib/validators';
// import { Validations } from 'vuelidate-property-decorators';

import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import SelectPortal from '@/components/edit/SelectPortal/index.vue'

import { validationMixin } from 'vuelidate'
import { required, email, minLength, between } from 'vuelidate/lib/validators'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import { Validations } from 'vuelidate-property-decorators'

import { cloneDeep } from 'lodash'
import utils from '@/helpers/utils'

library.add(faTrashAlt)

@Component({
	components: {
		Loader,
		SelectPortal,
	},
	mixins: [validationMixin],
})
export default class TableGroups extends Vue {
	result = null
	saving = false

	data() {
		return {
			email: '',
			url: '',
		}
	}

	get invalid() {
		return this.$v.email.$invalid || this.$v.url.$invalid
	}

	get submittable() {
		return !this.invalid && !this.saving
	}

	mustBeCool = (value) => value === 'tenho certeza'

	@Validations()
	validations() {
		return {
			email: {
				required,
				email,
			},
			url: {
				required,
			},
		}
	}

	async submit(e) {
		e.preventDefault()

		if (this.submittable) {
			this.saving = true
			const data = await this.$store.dispatch('startChallenge', {
				email: this.$v.email.$model,
				url: this.$v.url.$model,
			})

			this.saving = false
			this.result = data
		}
	}
}
